import callApi from '../../util/apiCaller';

import { addError } from '../Error/ErrorActions';

export const SET_CONFIGS = 'SET_CONFIGS';

export function getAllConfigRequest() {
    return dispatch => {
        return callApi('configs').then(res => {
            res.configs && dispatch(setConfigs(res.configs));
            return res.configs;
        }).catch(error => {
            dispatch(addError(error));
            return null;
        });
    };
}

export function getConfigRequest(key) {
    return dispatch => {
        return callApi(`config/${key}`).then(res => {
            res.config && dispatch(setConfigs([res.config]));
            return res.config;
        }).catch(error => {
            // dispatch(addError(error));
            return null;
        });
    };
}

export function editConfigRequest(config) {
    return dispatch => {
        return callApi('config/edit', 'post', { config }).then(res => {
            return res.config;
        }).catch(error => {
            dispatch(addError(error));
            return null;
        });
    };
}

// Getters
export function getConfig(store, key) {
    return (store.config.data.find(config => config.key === key) || {}).value || null;
}

// Actions
export function setConfigs(configs) {
    return {
        type: SET_CONFIGS,
        configs,
    };
}
